// extracted by mini-css-extract-plugin
export default {"card":"MateAdv_card__IcXds","ign":"MateAdv_ign__8YBVj","delButton":"MateAdv_delButton__SK9iq"};